import React, { useEffect, useState } from "react";
import { checkEmail, loginAnonymously } from '../../utils/api';
import InputField from "./InputField";
import UIButton from "../../../../globalComponents/UIComponents/UIButton";
import CButton from "../UI/CButton";

export default ({
    $locale,
    eventKey,
    enterOnly,
    participationType,
    allowAnonymousLogin,
    corporateMail,
    onSuccess = () => {},
    onWindowResize = () => { },
}) => {
    const [email, setEmail] = useState('')
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    useEffect(onWindowResize, [error]);

    const handleSetError = (value) => {
        if (value) return;

        setError({ hasError: true, name: '' });
        setShowErrorMessage(true);

        return;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (disabled || error) return;

        handleSetError(email);

        setDisabled(true);

        try {
            const response = await checkEmail(eventKey, { email, sendMail: false });

            if (enterOnly && (!!response.requiredFields)) {
                setError({ hasError: true, name: 'registration.enterOnly' });
                setDisabled(false);

                return;
            }

            onSuccess(response);
        } catch (e) {
            console.log(e);
            setDisabled(false);

            if (e.data?.error?.message === $locale.get('registration.emailNotAllowed')) {
                setError({
                    hasError: true,
                    name: corporateMail ? 'registration.useCorporateMail' : 'registration.accessClosed',
                });

                return;
            }

            setError({ hasError: true, name: !email ? '' : 'registration.wrongFormat' });
        }
    };

    const handleAnonymousLogin = async () => {
        if (disabled) {
            return;
        }
        setDisabled(true);
        try {
            const _participationType = ['hybrid', ''].includes(participationType) ? localStorage.getItem(`participationType_${eventKey}`) : undefined;
            const response = await loginAnonymously(eventKey, { participationType: _participationType });
            if (response.participationType) {
                localStorage.setItem(`participationType_${eventKey}`, response.participationType);
            }
            onSuccess(response);
        } catch (e) {
            console.error(e);
            setDisabled(false);
        }
    }

    return (
        <form
            onSubmit={handleSubmit}
            noValidate
            className="auth-container"
        >
            <InputField
                label={$locale.get('auth.login.email.email')}
                type="email"
                name="email"
                value={email}
                disabled={disabled}
                required
                placeholder={$locale.get('registration.placeholder.email')}
                error={error?.hasError}
                errorName={error?.name ? $locale.get(error?.name) : ''}
                onChange={(value) => {
                    setEmail(value);
                    setError(null);
                    setShowErrorMessage(false);
                }}
                onBlur={(e) => handleSetError(e.target.value)}
                $locale={$locale}
            />
            {showErrorMessage && (
                <p className="error-message">* {$locale.get('auth.login.fillRequiredFields')}</p>
            )}
            <div className="auth-submit-buttons">
                <UIButton
                    type="submit"
                    size="large"
                    style={email.length && !disabled && !error ? 'primary' : 'not-active'}
                    disabled={disabled}
                >
                    {$locale.get('guide.next')}
                </UIButton>
                {allowAnonymousLogin &&
                    <div>
                        {$locale.get('common.or')}
                        &nbsp;&nbsp;
                        <CButton
                            blank
                            label={$locale.get('auth.login.button.loginAnonymously')}
                            className={'comdi-button--text comdi-button--text-primary'}
                            onClick={handleAnonymousLogin}
                        />
                    </div>
                }
            </div>
        </form>
    );
}
